// Typelizer digest ff15bd52fae9f55345c84998eb408a11
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/ledger/accounts */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/accounts', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/ledger/accounts/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/accounts/:id', params, options),
    method: 'get',
  }),
}
